export const translations = {
  en: {
    'Social Network': 'Social Network',
    'Facebook': 'Facebook',
    'Twitter': 'Twitter',
    'Linkedin': 'Linkedin',
    'Instagram': 'Instagram',
    'Write about your company...': 'Write about your company...',
    'Remove company:': 'Remove company:',
    'from your profile': 'from your profile',
    'Remove Company': 'Remove Company',
    'Warning:': 'Warning:',
    'Are you sure you want to remove': 'Are you sure you want to remove',
    'from your profile? This action cannot be undone.': 'from your profile? This action cannot be undone.',
    'External Apply Link (Optional)': 'External Apply Link (Optional)',
    'If provided, candidates will be redirected here instead of applying via email.': 'If provided, candidates will be redirected here instead of applying via email.',
    'Apply via WhatsApp (Optional)': 'Apply via WhatsApp (Optional)',
    'If provided, candidates can apply by sending a message to this WhatsApp number.': 'If provided, candidates can apply by sending a message to this WhatsApp number.',
    'Specify e-mail': 'Specify e-mail',
    'To enter multiple emails, use ","': 'To enter multiple emails, use ","',
    'Mini Preview': 'Mini Preview',
    'Add Vacancy': 'Add Vacancy',
    'Publish a vacancy, receive and search resumes easily': 'Publish a vacancy, receive and search resumes easily',
    'Full Time': 'Full Time',
    'Part Time': 'Part Time',
    'Në Zyrë': 'On-site',
    'Internship': 'Internship',
    'Seasonal': 'Seasonal',
    'Temporary': 'Temporary',
    'Freelance': 'Freelance',
    'Contract': 'Contract',
    'Access Denied': 'Access Denied',
    'You must be a company account to view saved candidates.': 'You must be a company account to view saved candidates.',
    'No saved candidates found.': 'No saved candidates found.',
    'Remove from saved': 'Remove from saved',
    'CV Builder': 'CV Builder',
    'Click any text directly on the CV to edit it inline. Drag and drop sections using the dotted handle to reorder them.': 'Click any text directly on the CV to edit it inline. Drag and drop sections using the dotted handle to reorder them.',
    'Note:': 'Note:',
    'A dashed red line will appear if your content exceeds a single A4 page.': 'A dashed red line will appear if your content exceeds a single A4 page.',
    'Upload & Import CV PDF': 'Upload & Import CV PDF',
    'Importing from PDF...': 'Importing from PDF...',
    'Import data from Profile': 'Import data from Profile',
    'Start Blank': 'Start Blank',
    'Download PDF': 'Download PDF',
    'Templates': 'Templates',
    'Color Palette': 'Color Palette',
    'Selected': 'Selected',
    'Template 1': 'Template 1',
    'Template 2': 'Template 2',
    'A4 Format Size Preview': 'A4 Format Size Preview',
    'Decrease Font Size': 'Decrease Font Size',
    'Increase Font Size': 'Increase Font Size',
    'Saved ✓': 'Saved ✓',
    'Save CV to Profile': 'Save CV to Profile',
    '+ Add Experience': '+ Add Experience',
    '+ Add Skill': '+ Add Skill',
    'Hidden Profile': 'Hidden Profile',
    'Visible Profile': 'Visible Profile',
    'Copy Profile Link': 'Copy Profile Link',
    'Bulk profile edit': 'Bulk profile edit',
    'Download CV': 'Download CV',
    'Edit/Add': 'Edit/Add',
    'Show More': 'Show More',
    'Show Less': 'Show Less',
    'Location:': 'Location:',
    'Age:': 'Age:',
    'Age': 'Age',
    'Years': 'Years',
    'Email:': 'Email:',
    'Mobile Phone:': 'Mobile Phone:',
    'Mobile Phone': 'Mobile Phone',
    'Hidden': 'Hidden',
    'Visible': 'Visible',
    'Education Level:': 'Education Level:',
    'Education Level': 'Education Level',
    'Language:': 'Language:',
    'Gender:': 'Gender:',
    'Social media': 'Social media',
    'Professional Skills': 'Professional Skills',
    'No skills added': 'No skills added',
    'Write a short summary about yourself.': 'Write a short summary about yourself.',
    'No work experience added.': 'No work experience added.',
    'No education added.': 'No education added.',
    'Trainings': 'Trainings',
    'No trainings added.': 'No trainings added.',
    'Master Degree': 'Master Degree',
    'Bachelor Degree': 'Bachelor Degree',
    'Master\'s Degree': 'Master\'s Degree',
    'Bachelor\'s Degree': 'Bachelor\'s Degree',
    'High School Diploma': 'High School Diploma',
    'Vocational / Professional Diploma': 'Vocational / Professional Diploma',
    'Associate Degree': 'Associate Degree',
    'Professional Master': 'Professional Master',
    'Master of Science (M.Sc.)': 'Master of Science (M.Sc.)',
    'Master of Arts (M.A.)': 'Master of Arts (M.A.)',
    'Integrated Master Degree': 'Integrated Master Degree',
    'Doctorate (Ph.D.)': 'Doctorate (Ph.D.)',
    'Post-Doctoral': 'Post-Doctoral',
    'Primary / 9-Year Education': 'Primary / 9-Year Education',
    'Without Education': 'Without Education',
    'Select Gender': 'Select Gender',
    'English': 'English',
    'German': 'German',
    'Spanish': 'Spanish',
    'Italian': 'Italian',
    'French': 'French',
    'Albanian': 'Albanian',
    'Albania': 'Albania',
    '+ Add Work Experience': '+ Add Work Experience',
    '+ Add Education': '+ Add Education',
    '+ Add Training': '+ Add Training',
    '+ Add Language': '+ Add Language',
    'Company': 'Company',
    'Description': 'Description',
    'Dates (e.g. 2019-2021)': 'Dates (e.g. 2019-2021)',
    'Degree / Program': 'Degree / Program',
    'School/University': 'School/University',
    'Dates (e.g. 2015-2019)': 'Dates (e.g. 2015-2019)',
    'Training Program Title': 'Training Program Title',
    'Organization / Institution': 'Organization / Institution',
    'Dates (e.g. Nov 2017 - Oct 2018)': 'Dates (e.g. Nov 2017 - Oct 2018)',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    'Vacancies': 'Vacancies',
    'Companies': 'Companies',
    'Candidates': 'Candidates',
    'Salary Calculator': 'Salary Calculator',
    'Courses and Trainings': 'Courses and Trainings',
    'Create CV': 'Create CV',
    'Company account': 'Company account',
    'Log in': 'Log in',
    'Register': 'Register',
    'New': 'New',
    'Find Job': 'Find Job',
    'Hire Experts or be hired': 'Hire Experts or be hired',
    'Explore Jobs, Build Your CV': 'Explore Jobs, Build Your CV',
    '& Hire Top Talent.': '& Hire Top Talent.',
    'Your all-in-one platform in Albania to discover opportunities, build professional resumes, and connect with top employers.': 'Your all-in-one platform in Albania to discover opportunities, build professional resumes, and connect with top employers.',
    'Categories': 'Categories',
    'What job are you looking for?': 'What job are you looking for?',
    'Where?': 'Where?',
    'All Categories': 'All Categories',
    'Job title, Skill, Industry': 'Job title, Skill, Industry',
    'City': 'City',
    'Search': 'Search',
    'Need more search options?': 'Need more search options?',
    'Advanced Search': 'Advanced Search',
    'Latest Vacancies': 'Latest Vacancies',
    'All vacancies': 'All vacancies',
    'Trending Jobs': 'Trending Jobs',
    'Top Hiring Companies': 'Top Hiring Companies',
    'All companies': 'All companies',
    'Banking & Finance': 'Banking & Finance',
    'IT & Software': 'IT & Software',
    'Sales & Trade': 'Sales & Trade',
    'Healthcare & Medicine': 'Healthcare & Medicine',
    'Education & Training': 'Education & Training',
    'Marketing & PR': 'Marketing & PR',
    'Media & Communications': 'Media & Communications',
    'Construction & Real Estate': 'Construction & Real Estate',
    'Hospitality & Tourism': 'Hospitality & Tourism',
    'Logistics & Transportation': 'Logistics & Transportation',
    'Legal Services': 'Legal Services',
    'Human Resources': 'Human Resources',
    'Aesthetics & Beauty': 'Aesthetics & Beauty',
    'Customer Service': 'Customer Service',
    'Manufacturing & Production': 'Manufacturing & Production',
    'Arts & Design': 'Arts & Design',
    'Consulting': 'Consulting',
    'Public Sector & Government': 'Public Sector & Government',
    'Science & Research': 'Science & Research',
    'Agriculture & Environment': 'Agriculture & Environment',
    'Aviation': 'Aviation',
    'Agjent Shitje': 'Sales Agent',
    'Analist Kredie': 'Credit Analyst',
    'Arkitekt': 'Architect',
    'Arkëtar': 'Treasurer',
    'Arkëtar Banke': 'Bank Teller',
    'Asistent Finance': 'Finance Assistant',
    'Asistent Menaxher': 'Assistant Manager',
    'Banakier': 'Bartender',
    'Ekonomist': 'Economist',
    'Financier': 'Financier',
    'Hidraulik': 'Plumber',
    'Inxhinier': 'Engineer',
    'Inxhinier Mekanik': 'Mechanical Engineer',
    'Inxhinier Ndërtimi': 'Civil Engineer',
    'Kamarier': 'Waiter',
    'Kasier': 'Cashier',
    'Koordinator': 'Coordinator',
    'Kuzhinier': 'Cook',
    'Magazinier': 'Warehouse Worker',
    'Menaxher Marketingu': 'Marketing Manager',
    'Menaxher Shitjesh': 'Sales Manager',
    'Employee': 'Employee',
    'Employees': 'Employees',
    'Subscriber': 'Follower',
    'Subscribers': 'Followers',
    'Follower': 'Follower',
    'Followers': 'Followers',
    'Subscribe': 'Follow',
    'Unsubscribe': 'Unfollow',
    'Followed companies': 'Followed companies',
    'No Followed Companies': 'No Followed Companies',
    'On-site': 'On-site',
    'Vacancy': 'Vacancy',
    'Open vacancy': 'Open vacancy',
    'Open vacancies': 'Open vacancies',
    'Full time': 'Full time',
    'Full-time': 'Full-time',
    'Part time': 'Part time',
    'Part-time': 'Part-time',
    'Night shift': 'Night shift',
    'Filters': 'Filters',
    'Location': 'Location',
    'See all': 'See all',
    'Salary range': 'Salary range',
    'Minimum': 'Minimum',
    'Maximum': 'Maximum',
    'Salary negotiable': 'Salary negotiable',
    'Clear': 'Clear',
    'Confirm': 'Confirm',
    'Work schedule': 'Work schedule',
    'Flexible': 'Flexible',
    'Work format': 'Work format',
    'Office': 'Office',
    'Remote': 'Remote',
    'Hybrid': 'Hybrid',
    'Work experience': 'Work experience',
    'Without experience': 'Without experience',
    '1-2 years': '1-2 years',
    '3-4 years': '3-4 years',
    '5+ years': '5+ years',
    'Education': 'Education',
    'Student': 'Student',
    'Bachelor': 'Bachelor',
    'Master': 'Master',
    'PHD': 'PHD',
    'Graduate': 'Graduate',
    'Professor': 'Professor',
    'Resident': 'Resident',
    'Aspirant': 'Aspirant',
    'Academician': 'Academician',
    'Specialist': 'Specialist',
    'Show less': 'Show less',
    'Without education': 'Without education',
    'Premium Add-ons': 'Premium Add-ons',
    'Make this vacancy Featured': 'Make this vacancy Featured',
    'Featured vacancies are displayed at the top of the homepage and search results.': 'Featured vacancies are displayed at the top of the homepage and search results.',
    'You have 2 free features remaining this month.': 'You have 2 free features remaining this month.',
    'Free left': 'Free left',
    'Të gjitha Kategoritë': 'All Categories',
    'General Information': 'General Information',
    'Personal Information': 'Personal Information',
    'Contact': 'Contact',
    'Living Place': 'Living Place',
    'About Me': 'About Me',
    'Experience & Education': 'Experience & Education',
    'Skills & Languages': 'Skills & Languages',
    'To Be Filled': 'To Be Filled',
    'Filled': 'Filled',
    'Active': 'Active',
    'Completed': 'Completed',
    'User Personal Information': 'User Personal Information',
    'Profile Warning': 'The information you fill out in your profile will be used to automatically generate your CV and send it to employers when you apply for jobs. Please ensure your details are accurate!',
    'CV Picture': 'CV Picture',
    'Max Image Size': 'The maximum size of a JPG, JPEG, or PNG document is 10 MB',
    'Change Image': 'Change Image',
    'Name': 'Name',
    'Surname': 'Surname',
    'Gender': 'Gender',
    'Male': 'Male',
    'Female': 'Female',
    'Other': 'Other',
    'Birth Date': 'Birth Date',
    'Profession': 'Profession',
    'Contact Information': 'Contact Information',
    'Phone Number': 'Phone Number',
    'Email Address': 'Email Address',
    'Address': 'Address',
    'Address Warning': 'You will receive tailored vacancies through the address',
    'Country': 'Country',
    'Select Country': 'Select Country',
    'Select City': 'Select City',
    'Postal Code': 'Postal Code',
    'About Me Subtitle': 'Write a short summary about yourself',
    'Experience Subtitle': 'Add your past work and school entries',
    'Work Experience': 'Work Experience',
    'Job Title': 'Job Title',
    'Company Name': 'Company Name',
    'Start Date': 'Start Date',
    'End Date': 'End Date',
    'I currently work here': 'I currently work here',
    'Degree': 'Degree',
    'School': 'School',
    'Dates': 'Dates',
    'Skills & Languages Subtitle': 'Complete your profile with skills and languages',
    'Skills': 'Skills',
    'Add Skill': 'Add Skill',
    'Languages': 'Languages',
    'Language': 'Language',
    'Level': 'Level',
    'Native': 'Native',
    'Fluent': 'Fluent',
    'Intermediate': 'Intermediate',
    'Beginner': 'Beginner',
    'Add Language': 'Add Language',
    'Back': 'Back',
    'Continue': 'Continue',
    'Save': 'Save',
    'Saving...': 'Saving...',
    'Saved': 'Saved',
    'Remove': 'Remove',
    'Add Education': 'Add Education',
    'Add Work Experience': 'Add Work Experience',
    'Upgrade to Company Account': 'Upgrade to Company Account',
    'Cancel': 'Cancel',
    'Confirm & Upgrade': 'Confirm & Upgrade',
    'Anonymous feedback': 'Anonymous feedback',
    'Community Feedback': 'Community Feedback',
    '100% Free': '100% Free',
    'Create a Standout CV in Minutes': 'Create a Standout CV in Minutes',
    'Use our powerful CV Builder to craft professional, beautifully designed resumes that catch the eye of top recruiters.': 'Use our powerful CV Builder to craft professional, beautifully designed resumes that catch the eye of top recruiters.',
    'Build My CV': 'Build My CV',
    'Recent News Articles': 'Recent News Articles',
    'Fresh job related news content posted each day.': 'Fresh job related news content posted each day.',
    'Read More': 'Read More',
    'All Blog': 'All Blog',
    'No articles found.': 'No articles found.',
    'Navigation': 'Navigation',
    'Profile': 'Profile',
    'Generate CV': 'Generate CV',
    'Company registration': 'Company registration',
    'Create profile': 'Create profile',
    'Edit info': 'Edit info',
    'Help': 'Help',
    'Frequently asked questions': 'Frequently asked questions',
    'Cookie Policy': 'Cookie Policy',
    'Privacy Policy': 'Privacy Policy',
    'Terms of Service': 'Terms of Service',
    'All rights reserved': 'All rights reserved',
    'Avg. salary': 'Avg. salary',
    'Employment Type': 'Employment Type',
    'Required experience': 'Required experience',
    'Required degree': 'Required degree',
    'Email': 'Email',
    'Industry': 'Industry',
    'My profile': 'My profile',
    'Saved vacancies': 'Saved vacancies',
    'Applied vacancies': 'Applied vacancies',
    'View vacancy': 'View vacancy',
    'Applied on': 'Applied on',
    'No applied vacancies found.': 'No applied vacancies found.',
    'No saved vacancies found.': 'No saved vacancies found.',
    'Saved candidates': 'Saved candidates',
    'Notifications': 'Notifications',
    'Log out': 'Log out',
    'Free': 'Free',
    'About company': 'About company',
    'Applied': 'Applied',
    'Apply': 'Apply',
    'Follow': 'Follow',
    'Following': 'Following',
    'followers': 'followers',
    'employees': 'employees',
    'User ID': 'User ID',
    'All': 'All',
    'In review': 'In review',
    'Interview': 'Interview',
    'Reserve': 'Reserve',
    'Hired': 'Hired',
    'Rejected': 'Rejected',
    'Suggested': 'Suggested',
    'Applicant': 'Applicant',
    'Status': 'Status',
    'Resume': 'Resume',
    'View Resume': 'View Resume',
    'No Resume': 'No Resume',
    'No resumes received yet.': 'No resumes received yet.',
    'My Vacancies': 'My Vacancies',
    '+ Add Vacancy': '+ Add Vacancy',
    'Title': 'Title',
    'Job Created': 'Job Created',
    'Action': 'Action',
    'View': 'View',
    'Edit': 'Edit',
    'Hide': 'Hide',
    'Delete': 'Delete',
    'Premium Features are FREE!': 'Premium Features are FREE!',
    'To celebrate our launch, all premium features including Featured Vacancies are completely free for the next 2 years.': 'To celebrate our launch, all premium features including Featured Vacancies are completely free for the next 2 years.',
    'Your Current Balance': 'Your Current Balance',
    'You can use these credits when publishing a new vacancy.': 'You can use these credits when publishing a new vacancy.',
    '0 Credits': '0 Credits',
    'Credits': 'Credits',
    'Unlimited Vacancies': 'Unlimited Vacancies',
    'Grow your team without limits. You can now post unlimited featured vacancies and appear at the top of search results—absolutely free.': 'Grow your team without limits. You can now post unlimited featured vacancies and appear at the top of search results—absolutely free.',
    'Active until 2028': 'Active until 2028',
    'Published': 'Published',
    'Expires': 'Expires',
    'Today': 'Today',
    'Next': 'Next',
    'Month': 'Month',
    'Week': 'Week',
    'Day': 'Day',
    'Agenda': 'Agenda',
    'Date': 'Date',
    'Time': 'Time',
    'Event': 'Event',
    'No events in this range.': 'No events in this range.',
    'more': 'more',
    'Company Gallery (max 8 images)': 'Company Gallery (max 8 images)',
    'Edit Vacancy': 'Edit Vacancy',
    'Vacancy Title (ALB)': 'Vacancy Title (ALB)',
    'Vacancy Title (ENG)': 'Vacancy Title (ENG)',
    'Save Changes': 'Save Changes',
    'Upload images of your office, team, or events. Max 3MB per image.': 'Upload images of your office, team, or events. Max 3MB per image.',
    'Add Images': 'Add Images',
    'Save Profile': 'Save Profile',
    'Company Profile saved successfully!': 'Company Profile saved successfully!',
    'Company User': 'Company User',
    'Administrator': 'Administrator',
    'Account email:': 'Account email:',
    'Company Settings': 'Company Settings',
    'FAQ': 'FAQ',
    'Find answers to common questions about managing your company profile and vacancies.': 'Find answers to common questions about managing your company profile and vacancies.',
    'How do I add a new company?': 'How do I add a new company?',
    'You can add a new company directly during your account registration. Simply choose to create a new company, fill in your company details like name, logo, and description, and your company profile will be created instantly.': 'You can add a new company directly during your account registration. Simply choose to create a new company, fill in your company details like name, logo, and description, and your company profile will be created instantly.',
    'How do I claim an existing company from the database?': 'How do I claim an existing company from the database?',
    'If your company is already listed in our database, you can claim it by searching for its name during registration. After selecting it, you may need to verify your ownership using an official company email or by contacting our support team for verification.': 'If your company is already listed in our database, you can claim it by searching for its name during registration. After selecting it, you may need to verify your ownership using an official company email or by contacting our support team for verification.',
    'How do I post a new vacancy?': 'How do I post a new vacancy?',
    'Click on the "+ Add Vacancy" button in the My Vacancies section. Fill in the job details, requirements, and click "Submit". Your vacancy will be published immediately or saved as a draft.': 'Click on the "+ Add Vacancy" button in the My Vacancies section. Fill in the job details, requirements, and click "Submit". Your vacancy will be published immediately or saved as a draft.',
    'How much does it cost to post a vacancy?': 'How much does it cost to post a vacancy?',
    'To celebrate our launch, all premium features including posting unlimited featured vacancies are completely free for the next 2 years!': 'To celebrate our launch, all premium features including posting unlimited featured vacancies are completely free for the next 2 years!',
    'Can I edit or hide a vacancy after posting?': 'Can I edit or hide a vacancy after posting?',
    'Yes, you can edit or hide a vacancy at any time from the "My Vacancies" page. Hidden vacancies will no longer be visible to candidates.': 'Yes, you can edit or hide a vacancy at any time from the "My Vacancies" page. Hidden vacancies will no longer be visible to candidates.',
    'How do I view candidates who applied for my jobs?': 'How do I view candidates who applied for my jobs?',
    'Navigate to the "Received" section in your dashboard. You will see a list of all applicants, their resumes, and contact information.': 'Navigate to the "Received" section in your dashboard. You will see a list of all applicants, their resumes, and contact information.',
    'What are "Suggested" and "Reserve" statuses?': 'What are "Suggested" and "Reserve" statuses?',
    'You can organize applicants by moving them to "Suggested" (top candidates), "Interview" (scheduled for an interview), or "Reserve" (good candidates for future roles).': 'You can organize applicants by moving them to "Suggested" (top candidates), "Interview" (scheduled for an interview), or "Reserve" (good candidates for future roles).',
    'How do I upload images to my Company Gallery?': 'How do I upload images to my Company Gallery?',
    'Go to "Company Profile" (Settings) and scroll down to the "Company Gallery" section. You can upload up to 8 images (max 3MB each) showcasing your office and team.': 'Go to "Company Profile" (Settings) and scroll down to the "Company Gallery" section. You can upload up to 8 images (max 3MB each) showcasing your office and team.',
    'How does the Calendar work?': 'How does the Calendar work?',
    'The Calendar automatically tracks your vacancy publishing dates and expiration dates. This helps you keep a clear timeline of all your active job postings.': 'The Calendar automatically tracks your vacancy publishing dates and expiration dates. This helps you keep a clear timeline of all your active job postings.',
    'How do I enable Two-Factor Authentication (2FA)?': 'How do I enable Two-Factor Authentication (2FA)?',
    'Go to the "Security" page in your dashboard. Enter your phone number and click "Activate". You will receive an SMS code to verify and secure your account.': 'Go to the "Security" page in your dashboard. Enter your phone number and click "Activate". You will receive an SMS code to verify and secure your account.',
    'Two-Factor Authentication': 'Two-Factor Authentication',
    'When activating/deactivating, an SMS code will be sent to the number you specified.': 'When activating/deactivating, an SMS code will be sent to the number you specified.',
    'Activate': 'Activate',
    'Set Password': 'Set Password',
    'Since you logged in with a social account, you can set a password to log in directly via email in the future.': 'Since you logged in with a social account, you can set a password to log in directly via email in the future.',
    'New Password': 'New Password',
    'Enter new password': 'Enter new password',
    'Confirm New Password': 'Confirm New Password',
    'Confirm new password': 'Confirm new password',
    'Who can use two-factor authentication?': 'Who can use two-factor authentication?',
    'All users added to the company will be able to log into the system using their specified numbers.': 'All users added to the company will be able to log into the system using their specified numbers.',
    'What does two-factor authentication protect in my system?': 'What does two-factor authentication protect in my system?',
    'With two-factor authentication, you can increase the level of security in your system.': 'With two-factor authentication, you can increase the level of security in your system.',
    'Company Profile!': 'Company Profile!',
    'Ready to jump back in?': 'Ready to jump back in?',
    'Company logo': 'Company logo',
    'Upload new photo': 'Upload new photo',
    'Company name *': 'Company name *',
    'Email address *': 'Email address *',
    'Phone *': 'Phone *',
    'Visible on public profile': 'Visible on public profile',
    'Website': 'Website',
    'Founded Date': 'Founded Date',
    'Team Size': 'Team Size',
    'Import And Claim Company': 'Import And Claim Company',
  },
  'Administrator Biznesi': 'Business Administrator',
  'Administrim': 'Administration',
  'Agjent i Ruajtjes Fizike': 'Physical Security Agent',
  'Agjent Imobiliar': 'Real Estate Agent',
  'Agjent Shitje': 'Sales Agent',
  'Agjent Shitjesh Ex-Van': 'Ex-Van Sales Agent',
  'Agjent Shitjesh Horeca': 'Horeca Sales Agent',
  'Agjent Shpërndarje': 'Delivery Agent',
  'Agjent Udhëtimi': 'Travel Agent',
  'Analist Biznesi': 'Business Analyst',
  'Analist Kredie': 'Credit Analyst',
  'Analist Ligjor': 'Legal Analyst',
  'Analist Sistemi': 'System Analyst',
  'Arkëtar': 'Treasurer',
  'Arkëtar Banke': 'Bank Teller',
  'Arkëtar Kase': 'Cashier',
  'Arkitekt': 'Architect',
  'Art dhe Televizion': 'Art and Television',
  'Asistent Administrativ': 'Administrative Assistant',
  'Asistent Dentar': 'Dental Assistant',
  'Asistent Ekzekutiv': 'Executive Assistant',
  'Asistent Finance': 'Finance Assistant',
  'Asistent i Burimeve Njerëzore': 'HR Assistant',
  'Asistent Menaxher': 'Assistant Manager',
  'Asistent Zyre': 'Office Assistant',
  'Auditor': 'Auditor',
  'Back Office': 'Back Office',
  'Banakier': 'Bartender',
  'Barist': 'Barista',
  'Berber': 'Barber',
  'Biznes-Menaxhim Strategjik': 'Strategic Management',
  'Bojaxhi': 'Painter',
  'Bukëpjekës': 'Baker',
  'Burime Njerëzore': 'Human Resources',
  'Data entry': 'Data Entry',
  'Dizajner': 'Designer',
  'Drejtor Finance': 'Finance Director',
  'Drejtor Hoteli': 'Hotel Director',
  'Drejtor Marketingu': 'Marketing Director',
  'Drejtor Shitjesh': 'Sales Director',
  'Drejtues Grupi': 'Team Leader',
  'Edukator': 'Educator',
  'Ekonomist': 'Economist',
  'Ekspert i Burimeve Njerëzore': 'HR Expert',
  'Elektriçist': 'Electrician',
  'Estetist': 'Aesthetician',
  'Financë': 'Finance',
  'Financier': 'Financier',
  'Full Stack Developer': 'Full Stack Developer',
  'Help Desk Support': 'Help Desk Support',
  'Hidraulik': 'Plumber',
  'HOREKA-Hoteleri-Restorant-Kafe': 'HORECA',
  'Infermier': 'Nurse',
  'Informaticien': 'IT Specialist',
  'Instalime-Mirëmbajtje': 'Installation & Maintenance',
  'Instruktor': 'Instructor',
  'Inventarizues': 'Inventory Clerk',
  'Inxhiner Sistemesh': 'Systems Engineer',
  'Inxhinier': 'Engineer',
  'Inxhinier Civil': 'Civil Engineer',
  'Inxhinier Ekonomik': 'Economic Engineer',
  'Inxhinier Elektrik': 'Electrical Engineer',
  'Inxhinier Informatike': 'IT Engineer',
  'Inxhinier Mekanik': 'Mechanical Engineer',
  'Inxhinier Mekatronik': 'Mechatronics Engineer',
  'Inxhinier Mjedisi': 'Environmental Engineer',
  'Inxhinier Ndërtimi': 'Construction Engineer',
  'Jurist': 'Lawyer',
  'Kamarier': 'Waiter',
  'Kasier': 'Cashier',
  'Konsulent Shitjesh': 'Sales Consultant',
  'Kontabël': 'Accountant',
  'Kontrollor Finance': 'Financial Controller',
  'Koordinator': 'Coordinator',
  'Koordinator Blerjesh': 'Purchasing Coordinator',
  'Koordinator Projektesh': 'Project Coordinator',
  'Koordinator Shërbimesh': 'Services Coordinator',
  'Korrier': 'Courier',
  'Kujdestar': 'Caretaker',
  'Kuzhinier': 'Cook',
  'Lavazhier': 'Car Washer',
  'Ligjore': 'Legal',
  'Magazinier': 'Warehouse Worker',
  'Manovrator': 'Operator',
  'Marangoz': 'Carpenter',
  'Marketing Dixhital': 'Digital Marketing',
  'Marketing-Produkte': 'Product Marketing',
  'Mbështetje për Lojrat dhe Klientin': 'Customer Support',
  'Mekanik': 'Mechanic',
  'Menaxher': 'Manager',
  'Menaxher Blerjesh': 'Purchasing Manager',
  'Menaxher Departamenti': 'Department Manager',
  'Menaxher Eventesh': 'Events Manager',
  'Menaxher i Marrëdhënieve me Klientin': 'CRM Manager',
  'Menaxher i Rekrutimit': 'Recruitment Manager',
  'Menaxher i Sigurisë Fizike': 'Security Manager',
  'Menaxher Logjistike': 'Logistics Manager',
  'Menaxher Marketingu': 'Marketing Manager',
  'Menaxher Operacional': 'Operations Manager',
  'Shitës': 'Vendor',
  'Shofer': 'Driver',
  'Operator': 'Operator',
  'Punëtor Magazine': 'Warehouse Worker',
  sq: {
    'Social Network': 'Rrjetet Sociale',
    'Facebook': 'Facebook',
    'Twitter': 'Twitter',
    'Linkedin': 'Linkedin',
    'Instagram': 'Instagram',
    'Write about your company...': 'Shkruani rreth kompanisë suaj...',
    'Remove company:': 'Hiq kompaninë:',
    'from your profile': 'nga profili juaj',
    'Remove Company': 'Hiq Kompaninë',
    'Warning:': 'Kujdes:',
    'Are you sure you want to remove': 'A jeni i sigurt që dëshironi të hiqni',
    'from your profile? This action cannot be undone.': 'nga profili juaj? Ky veprim nuk mund të kthehet prapa.',
    'External Apply Link (Optional)': 'Linku i jashtëm i aplikimit (Opsionale)',
    'If provided, candidates will be redirected here instead of applying via email.': 'Nëse plotësohet, kandidatët do të ridrejtohen këtu në vend që të aplikojnë me email.',
    'Apply via WhatsApp (Optional)': 'Apliko përmes WhatsApp (Opsionale)',
    'If provided, candidates can apply by sending a message to this WhatsApp number.': 'Nëse plotësohet, kandidatët mund të aplikojnë duke dërguar një mesazh në këtë numër WhatsApp.',
    'Specify e-mail': 'Specifiko email-in',
    'To enter multiple emails, use ","': 'Për të futur disa adresa email, përdorni ","',
    'Publish a vacancy, receive and search resumes easily': 'Publikoni një njoftim pune, merrni dhe kërkoni CV me lehtësi',
    'City': 'Qyteti',
    'Need more search options?': 'Keni nevojë për më shumë opsione kërkimi?',
    'Advanced Search': 'Kërkimi i avancuar',
    'Latest Vacancies': 'Vendet më të fundit të punës',
    'All vacancies': 'Të gjitha vendet e punës',
    'Subscribers': 'Abonuesit',
    'Të gjitha Kategoritë': 'Të gjitha Kategoritë',
    'Agjent Shitje': 'Agjent Shitje',
    'Analist Kredie': 'Analist Kredie',
    'Arkitekt': 'Arkitekt',
    'Arkëtar': 'Arkëtar',
    'Arkëtar Banke': 'Arkëtar Banke',
    'Asistent Finance': 'Asistent Finance',
    'Asistent Menaxher': 'Asistent Menaxher',
    'Banakier': 'Banakier',
    'Ekonomist': 'Ekonomist',
    'Financier': 'Financier',
    'Hidraulik': 'Hidraulik',
    'Inxhinier': 'Inxhinier',
    'Inxhinier Mekanik': 'Inxhinier Mekanik',
    'Inxhinier Ndërtimi': 'Inxhinier Ndërtimi',
    'Kamarier': 'Kamarier',
    'Kasier': 'Kasier',
    'Koordinator': 'Koordinator',
    'Kuzhinier': 'Kuzhinier',
    'Magazinier': 'Magazinier',
    'Menaxher Marketingu': 'Menaxher Marketingu',
    'Menaxher Shitjesh': 'Menaxher Shitjesh',
    'Grow your team without limits. You can now post unlimited featured vacancies and appear at the top of search results—absolutely free.': 'Rritni ekipin tuaj pa kufij. Tani mund të postoni njoftime të veçuara pa limit dhe të shfaqeni në krye të kërkimit—krejtësisht falas.',
    'Full Time': 'Orar i plotë',
    'Part Time': 'Me kohë të pjesshme',
    'Në Zyrë': 'Në zyrë',
    'Internship': 'Praktikë (Internship)',
    'Seasonal': 'Sezonale',
    'Temporary': 'E përkohshme',
    'Freelance': 'Freelance',
    'Contract': 'Me kontratë',
    'Access Denied': 'Qasja u Refuzua',
    'You must be a company account to view saved candidates.': 'Duhet të keni një llogari kompanie për të parë kandidatët e ruajtur.',
    'No saved candidates found.': 'Nuk u gjet asnjë kandidat i ruajtur.',
    'Remove from saved': 'Hiq nga të ruajturat',
    'CV Builder': 'Krijuesi i CV-së',
    'Click any text directly on the CV to edit it inline. Drag and drop sections using the dotted handle to reorder them.': 'Kliko mbi çdo tekst direkt në CV për ta redaktuar. Tërhiq dhe lësho seksionet duke përdorur dorezën me pika për t\'i rirenditur.',
    'Note:': 'Shënim:',
    'A dashed red line will appear if your content exceeds a single A4 page.': 'Një vijë e kuqe e ndërprerë do të shfaqet nëse përmbajtja juaj kalon një faqe të vetme A4.',
    'Upload & Import CV PDF': 'Ngarko & Importo CV në PDF',
    'Importing from PDF...': 'Duke importuar nga PDF...',
    'Import data from Profile': 'Importo të dhënat nga Profili',
    'Start Blank': 'Fillo nga e para',
    'Download PDF': 'Shkarko PDF',
    'Templates': 'Modelet',
    'Color Palette': 'Paleta e Ngjyrave',
    'Selected': 'Zgjedhur',
    'Template 1': 'Modeli 1',
    'Template 2': 'Modeli 2',
    'A4 Format Size Preview': 'Pamja paraprake në format A4',
    'Decrease Font Size': 'Zvogëlo madhësinë e shkrimit',
    'Increase Font Size': 'Zmadho madhësinë e shkrimit',
    'Saved ✓': 'E ruajtur ✓',
    'Save CV to Profile': 'Ruaj CV-në në Profil',
    '+ Add Experience': '+ Shto Eksperiencë',
    '+ Add Skill': '+ Shto Aftësi',
    'Hidden Profile': 'Profil i Fshehur',
    'Visible Profile': 'Profil i Dukshëm',
    'Copy Profile Link': 'Kopjo Linkun e Profilit',
    'Bulk profile edit': 'Redaktim masiv i profilit',
    'Download CV': 'Shkarko CV',
    'Edit/Add': 'Redakto/Shto',
    'Show More': 'Shiko më shumë',
    'Show Less': 'Shiko më pak',
    'Location:': 'Vendndodhja:',
    'Age:': 'Mosha:',
    'Age': 'Mosha',
    'Years': 'Vjeç',
    'Email:': 'Emaili:',
    'Mobile Phone:': 'Numri i Celularit:',
    'Mobile Phone': 'Numri i Celularit',
    'Hidden': 'I fshehur',
    'Visible': 'I dukshëm',
    'Education Level:': 'Niveli i Edukimit:',
    'Education Level': 'Niveli i Edukimit',
    'Language:': 'Gjuhët:',
    'Gender:': 'Gjinia:',
    'Social media': 'Rrjetet Sociale',
    'Professional Skills': 'Aftësitë Profesionale',
    'No skills added': 'Nuk janë shtuar aftësi',
    'Write a short summary about yourself.': 'Shkruani një përmbledhje të shkurtër për veten.',
    'No work experience added.': 'Nuk është shtuar asnjë eksperiencë pune.',
    'No education added.': 'Nuk është shtuar asnjë edukim.',
    'Trainings': 'Trajnime',
    'No trainings added.': 'Nuk janë shtuar trajnime.',
    'Master Degree': 'Diplomë Master',
    'Bachelor Degree': 'Diplomë Bachelor',
    'Master\'s Degree': 'Diplomë Master',
    'Bachelor\'s Degree': 'Diplomë Bachelor',
    'High School Diploma': 'Diplomë e Shkollës së Mesme',
    'Vocational / Professional Diploma': 'Diplomë Profesionale / Vokacionale',
    'Associate Degree': 'Diplomë Associate',
    'Professional Master': 'Master Profesional',
    'Master of Science (M.Sc.)': 'Master i Shkencave (M.Sc.)',
    'Master of Arts (M.A.)': 'Master i Arteve (M.A.)',
    'Integrated Master Degree': 'Master i Integruar',
    'Doctorate (Ph.D.)': 'Doktoraturë (Ph.D.)',
    'Post-Doctoral': 'Post-Doktoraturë',
    'Primary / 9-Year Education': 'Arsim 9-Vjeçar / Fillor',
    'Without Education': 'Pa Arsim',
    'Select Gender': 'Zgjidh Gjininë',
    'Spanish': 'Spanjisht',
    'Albania': 'Shqipëri',
    '+ Add Work Experience': '+ Shto Eksperiencë Pune',
    '+ Add Education': '+ Shto Edukim',
    '+ Add Training': '+ Shto Trajnim',
    '+ Add Language': '+ Shto Gjuhë',
    'Dates (e.g. 2019-2021)': 'Datat (psh. 2019-2021)',
    'Degree / Program': 'Diploma / Programi',
    'School/University': 'Shkolla / Universiteti',
    'Dates (e.g. 2015-2019)': 'Datat (psh. 2015-2019)',
    'Training Program Title': 'Titulli i Programit të Trajnimit',
    'Organization / Institution': 'Organizata / Institucioni',
    'Dates (e.g. Nov 2017 - Oct 2018)': 'Datat (psh. Nën 2017 - Tet 2018)',
    'Vacancies': 'Punë',
    'Companies': 'Kompani',
    'Candidates': 'Kandidatët',
    'Salary Calculator': 'Llogaritësi i Pagës',
    'Courses and Trainings': 'Kurse dhe Trajnime',
    'Create CV': 'Krijo CV',
    'Company account': 'Llogari kompanie',
    'Log in': 'Kyçu',
    'Register': 'Regjistrohu',
    'New': 'E Re',
    'Explore Jobs, Build Your CV': 'Njoftime Pune në Shqipëri, Krijo CV',
    '& Hire Top Talent.': '& Gjej Punën Tënde.',
    'Your all-in-one platform in Albania to discover opportunities, build professional resumes, and connect with top employers.': 'Portali kryesor në Shqipëri për të gjetur njoftime pune, krijuar CV profesionale falas dhe lidhur me punëdhënësit më të mirë.',
    'Categories': 'Kategoritë',
    'Add Vacancy': 'Shto Vend Pune',
    'Vacancy Title': 'Titulli i Pozicionit',
    'Category': 'Kategoria',
    'Subcategory': 'Nënkategoria',
    'Location': 'Vendndodhja',
    'No cities found.': 'Asnjë qytet nuk u gjet.',
    'Work schedule and format': 'Orari dhe formati i punës',
    'Work schedule': 'Orari i punës',
    'Work format': 'Formati i punës',
    'Education': 'Edukimi',
    'Salary': 'Paga',
    'Min': 'Min',
    'Max': 'Maks',
    'Rate per hour': 'Norma për orë',
    'Experience': 'Eksperienca',
    'Languages and Professional skills': 'Gjuhët dhe Aftësitë Profesionale',
    'Required languages': 'Gjuhët e kërkuara',
    'Choose language': 'Zgjidh gjuhën',
    'Choose level': 'Zgjidh nivelin',
    'Add': 'Shto',
    'Required Professional skills': 'Aftësitë Profesionale të kërkuara',
    'Select professional skills...': 'Zgjidh aftësitë profesionale...',
    'Additional Information': 'Informacion Shtesë',
    'Benefits offered by the company': 'Përfitimet e ofruara nga kompania',
    'Description': 'Përshkrimi',
    'Requirements': 'Kërkesat',
    'Application': 'Aplikimi',
    'Email for receiving applications': 'Email për të marrë aplikime',
    'Mini Preview': 'Mini Pamje Paraprake',
    'Job Title': 'Titulli i Punës',
    'Publish': 'Publiko',
    'Save Draft': 'Ruaj si draft',
    'Full time': 'Me kohë të plotë',
    'Part time': 'Me kohë të pjesshme',
    'Night shift': 'Turni i natës',
    'Flexible': 'Fleksibël',
    'Office': 'Në Zyrë',
    'Hybrid': 'Hibrid',
    'Remote': 'Në distancë',
    'Student': 'Student',
    'Bachelor': 'Bachelor',
    'Master': 'Master',
    'PHD': 'PHD',
    'Graduate': 'I diplomuar',
    'Professor': 'Profesor',
    'Resident': 'Rezident',
    'Aspirant': 'Aspirant',
    'Academician': 'Akademik',
    'Specialist': 'Specialist',
    'Without education': 'Pa edukim',
    'Without experience': 'Pa eksperiencë',
    '1-2 years': '1-2 vite',
    '3-4 years': '3-4 vite',
    '5+ years': '5+ vite',
    'Fixed': 'Fikse',
    'Range': 'Diapazon',
    'By agreement': 'Me marrëveshje',
    'Hourly': 'Me orë',
    'Resumes': 'CV-të',
    'Received': 'Të marra',
    'Profiles': 'Profile',
    'Calendar': 'Kalendari',
    'Packages': 'Paketat',
    'Security': 'Siguria',
    'Company Profile': 'Profili i Kompanisë',
    'Languages': 'Gjuhët',
    'Required professional skills:': 'Aftësitë profesionale të kërkuara:',
    'Subscribe': 'Ndiq',
    'Unsubscribe': 'Hiq',
    'Followed companies': 'Kompanitë e ndjekura',
    'No Followed Companies': 'Nuk ka kompani të ndjekura',
    'Apply for job': 'Apliko për punë',
    'Save vacancy': 'Ruaj vendin e punës',
    'Unsave vacancy': 'Hiq nga të ruajturat',
    'Italian': 'Italisht',
    'English': 'Anglisht',
    'German': 'Gjermanisht',
    'French': 'Frëngjisht',
    'Very Good': 'Shumë mirë',
    'Good': 'Mirë',
    'Basic': 'Bazë',
    'Excellent': 'Shkëlqyeshëm',
    'Training funding': 'Financim trajnimi',
    'Bonus': 'Bonus',
    'Corporate events': 'Evente korporate',
    'Gaming area': 'Zonë lojrash',
    'Benefits for children': 'Përfitime për fëmijët',
    'Successfully Followed!': 'Abonimi u krye me sukses!',
    'You will now receive notifications when': 'Tani do të merrni njoftime kur',
    'posts new jobs.': 'publikon vende të reja pune.',
    'Deadline': 'Afati',
    'Day off': 'Ditë pushimi',
    'Parking': 'Parkim',
    'Free coffee/tea': 'Kafe/Çaj falas',
    'Health Insurance': 'Sigurim shëndetësor',
    'Family Insurance': 'Sigurim familjar',
    'Cafeteria': 'Mensë',
    'Fitness Subscription': 'Abonim palestre',
    'Discounts': 'Zbritje',
    'Gift system': 'Sistem dhuratash',
    'Business trips': 'Udhëtime pune',
    'Mobile allowance': 'Kompensim telefonik',
    'Free meals': 'Ushqim falas',
    'Transportation': 'Transport',
    'Relaxation area': 'Zonë relaksi',
    'Vacancy Saved': 'Vendi i punës u ruajt',
    'Native': 'Gjuha amtare',
    'Average': 'Mesatare',
    'Beginner': 'Fillestar',
    'About company': 'Rreth kompanisë',
    'View company': 'Shiko kompaninë',
    'Website link': 'Uebfaqja',
    'Youtube video link': 'Video në Youtube',
    'Employee Number in company': 'Numri i punonjësve',
    'Founded in': 'Themeluar në',
    'Published: ': 'Publikuar më: ',
    'Youtube Video (Optional)': 'Video në Youtube (Opsionale)',
    'Settings': 'Cilësimet',
    'Publication Date': 'Data e publikimit',
    'Deadline Date': 'Data e skadimit',
    'Albanian': 'Shqip',
    'Write description in Albanian...': 'Shkruaj përshkrimin në Shqip...',
    'Write description in English...': 'Shkruaj përshkrimin në Anglisht...',
    'Vacancy': 'Vend pune',
    'Find Job': 'Gjej Punë',
    'Hire Experts or be hired': 'Punëso Ekspertë ose punësohu',
    'What job are you looking for?': 'Çfarë pune po kërkoni?',
    'Where?': 'Ku?',
    'All Categories': 'Të gjitha Kategoritë',
    'Job title, Skill, Industry': 'Titulli i punës, Aftësi, Industri',
    'Registered as:': 'Regjistruar si:',
    'Company': 'Kompani',
    'Administrator': 'Administrator',
    'Job Seeker': 'Kandidat',
    'Personal account': 'Llogari Personale',
    'Trending Jobs': 'Punë në Trend',
    'Top Hiring Companies': 'Top Punëdhënësit',
    'All companies': 'Të gjitha kompanitë',
    'Banking & Finance': 'Financë & Bankë',
    'IT & Software': 'IT & Softuer',
    'Sales & Trade': 'Shitje & Tregti',
    'Healthcare & Medicine': 'Shëndetësi & Mjekësi',
    'Education & Training': 'Arsim & Trajnim',
    'Marketing & PR': 'Marketing & PR',
    'Media & Communications': 'Media & Komunikim',
    'Construction & Real Estate': 'Ndërtim & Pasuri të Paluajtshme',
    'Hospitality & Tourism': 'Mikpritje & Turizëm',
    'Logistics & Transportation': 'Logjistikë & Transport',
    'Legal Services': 'Shërbime Ligjore',
    'Human Resources': 'Burime Njerëzore',
    'Aesthetics & Beauty': 'Estetikë & Bukuri',
    'Customer Service': 'Shërbim ndaj Klientit',
    'Manufacturing & Production': 'Prodhim & Manifakturë',
    'Arts & Design': 'Art & Dizajn',
    'Consulting': 'Konsulencë',
    'Public Sector & Government': 'Sektori Publik & Qeveria',
    'Science & Research': 'Shkencë & Kërkim',
    'Agriculture & Environment': 'Bujqësi & Mjedis',
    'Aviation': 'Aviacion',
    'Employee': 'Punonjës',
    'Subscriber': 'Ndjekës',
    'On-site': 'Në Zyrë',
    'Full-time': 'Me kohë të plotë',
    'Part-time': 'Me kohë të pjesshme',
    'Filters': 'Filtra',
    'See all': 'Shiko të gjitha',
    'Salary range': 'Gama e pagës',
    'Minimum': 'Minimumi',
    'Maximum': 'Maksimumi',
    'Salary negotiable': 'Paga e negociueshme',
    'Clear': 'Pastro',
    'Confirm': 'Konfirmo',
    'Work experience': 'Eksperienca e punës',
    'Show less': 'Shiko më pak',
    'Premium Add-ons': 'Shërbime Premium',
    'Make this vacancy Featured': 'Bëje këtë vend pune të Zgjedhur (Featured)',
    'Featured vacancies are displayed at the top of the homepage and search results.': 'Vendet e zgjedhura të punës shfaqen në krye të faqes kryesore dhe në rezultatet e kërkimit.',
    'You have 2 free features remaining this month.': 'Ju keni 2 përdorime falas të mbetura për këtë muaj.',
    'Free left': 'Të mbetura falas',
    'General Information': 'Informacion i Përgjithshëm',
    'Personal Information': 'Të dhëna Personale',
    'Contact': 'Kontakt',
    'Living Place': 'Vendbanimi',
    'About Me': 'Rreth Meje',
    'Experience & Education': 'Eksperienca & Edukimi',
    'Skills & Languages': 'Aftësitë & Gjuhët',
    'To Be Filled': 'Për t\'u Plotësuar',
    'Filled': 'Plotësuar',
    'Active': 'Aktiv',
    'Completed': 'Përfunduar',
    'User Personal Information': 'Informacioni Personal i Përdoruesit',
    'Profile Warning': 'Informacioni që plotësoni në profilin tuaj do të përdoret për të gjeneruar automatikisht CV-në tuaj dhe për t\'ua dërguar punëdhënësve kur aplikoni për punë. Sigurohuni që detajet tuaja të jenë të sakta!',
    'CV Picture': 'Foto e CV-së',
    'Max Image Size': 'Madhësia maksimale e një dokumenti JPG, JPEG ose PNG është 10 MB',
    'Change Image': 'Ndrysho Imazhin',
    'Name': 'Emri',
    'Surname': 'Mbiemri',
    'Gender': 'Gjinia',
    'Male': 'Mashkull',
    'Female': 'Femër',
    'Other': 'Tjetër',
    'Birth Date': 'Datëlindja',
    'Profession': 'Profesioni',
    'Contact Information': 'Informacioni i Kontaktit',
    'Phone Number': 'Numri i Telefonit',
    'Email Address': 'Adresa e Email-it',
    'Address': 'Adresa',
    'Address Warning': 'Ju do të merrni vende pune të përshtatshme përmes adresës',
    'Country': 'Shteti',
    'Select Country': 'Zgjidh Shtetin',
    'Select City': 'Zgjidh Qytetin',
    'Postal Code': 'Kodi Postar',
    'About Me Subtitle': 'Shkruaj një përmbledhje të shkurtër për veten',
    'Experience Subtitle': 'Shtoni të dhënat tuaja të kaluara të punës dhe shkollës',
    'Work Experience': 'Eksperienca e Punës',
    'Company Name': 'Emri i Kompanisë',
    'Start Date': 'Data e Fllimit',
    'End Date': 'Data e Përfundimit',
    'I currently work here': 'Unë aktualisht punoj këtu',
    'Degree': 'Grada',
    'School': 'Shkolla',
    'Dates': 'Datat',
    'Skills & Languages Subtitle': 'Plotësoni profilin tuaj me aftësi dhe gjuhë',
    'Skills': 'Aftësitë',
    'Add Skill': 'Shto Aftësi',
    'Language': 'Gjuha',
    'Level': 'Niveli',
    'Fluent': 'Rrjedhshëm',
    'Intermediate': 'Mesatare',
    'Add Language': 'Shto Gjuhë',
    'Back': 'Prapa',
    'Continue': 'Vazhdo',
    'Save': 'Ruaj',
    'Saving...': 'Duke ruajtur...',
    'Saved': 'E ruajtur',
    'Remove': 'Hiq',
    'Add Education': 'Shto Edukim',
    'Add Work Experience': 'Shto Eksperiencë Pune',
    'Upgrade to Company Account': 'Përmirëso në Llogari Kompanie',
    'Cancel': 'Anulo',
    'Confirm & Upgrade': 'Konfirmo dhe Përmirëso',
    'Anonymous feedback': 'Reagim anonim',
    'Community Feedback': 'Reagimet e Komunitetit',
    '100% Free': '100% FALAS',
    'Create a Standout CV in Minutes': 'Krijoni një CV të Shkëlqyer në Pak Minuta',
    'Use our powerful CV Builder to craft professional, beautifully designed resumes that catch the eye of top recruiters.': 'Përdorni krijuesin tonë të fuqishëm të CV-ve për të krijuar një rezyme profesionale që tërheq vëmendjen e punëdhënësve më të mirë.',
    'Build My CV': 'Krijo CV-në Time',
    'Recent News Articles': 'Artikujt më të Fundit',
    'Fresh job related news content posted each day.': 'Lajme dhe artikuj të freskët rreth punësimit çdo ditë.',
    'Read More': 'Lexo më shumë',
    'All Blog': 'Të gjithë Artikujt',
    'No articles found.': 'Nuk u gjet asnjë artikull.',
    'Navigation': 'Navigimi',
    'Profile': 'Profili',
    'Generate CV': 'Gjenero CV',
    'Company registration': 'Regjistrim kompanie',
    'Create profile': 'Krijo profil',
    'Edit info': 'Ndrysho të dhënat',
    'Help': 'Ndihmë',
    'Frequently asked questions': 'Pyetjet e shpeshta',
    'Cookie Policy': 'Politika e Cookies',
    'Privacy Policy': 'Politika e Privatësisë',
    'Terms of Service': 'Kushtet e Shërbimit',
    'All rights reserved': 'Të gjitha të drejtat të rezervuara',
    'Unlock powerful tools to find, connect with, and hire top talent in Albania. Transform your personal profile into a professional employer presence.': 'Zhbllokoni mjete të fuqishme për të gjetur, lidhur dhe punësuar talentet më të mirë në Shqipëri. Ktheni profilin tuaj personal në një prani profesionale punëdhënësi.',
    'Post Job Vacancies': 'Postoni Vende Pune',
    'Reach thousands of active job seekers by publishing your open roles instantly.': 'Arrijini mijëra punëkërkues aktiv duke publikuar rolet tuaja të hapura menjëherë.',
    'Company Dashboard': 'Paneli i Kompanisë',
    'Manage all your job listings, track applications, and view analytics in one place.': 'Menaxhoni të gjitha njoftimet tuaja për punë, gjurmoni aplikimet dhe shikoni analitikat në një vend.',
    'Build Your Brand': 'Ndërtoni Markën Tuaj',
    'Create a dedicated company profile page to showcase your culture and attract talent.': 'Krijoni një faqe profili të dedikuar kompanie për të shfaqur kulturën tuaj dhe tërhequr talentin.',
    'Ready to start hiring?': 'Gati për të filluar punësimin?',
    'This action will permanently convert your job seeker account into a company account. You will retain your login credentials, but your profile will function as an employer.': 'Ky veprim do të kthejë përgjithmonë llogarinë tuaj të punëkërkuest në një llogari kompanie. Ju do të mbani të njëjtat kredenciale logimi, por profili juaj do të funksionojë si punëdhënës.',
    'Confirm Upgrade': 'Konfirmo Përmirësimin',
    'Are you sure you want to become a company account? This action cannot be undone.': 'Jeni i sigurt që dëshironi të ktheheni në një llogari kompanie? Ky veprim nuk mund të kthehet mbrapsht.',

    'Welcome back': 'Mirësevini përsëri',
    'Log in to your account to continue': 'Hyni në llogarinë tuaj për të vazhduar',
    'Password': 'Fjalëkalimi',
    'Logging in...': 'Duke hyrë...',
    'or continue with': 'ose vazhdo me',
    'Continue with Google': 'Vazhdo me Google',
    "Don't have an account?": 'Nuk keni një llogari?',
    'Register here': 'Regjistrohu këtu',
    'Create an account': 'Krijoni një llogari',
    'Join us and find your dream job today': 'Bashkohuni me ne dhe gjeni punën tuaj të ëndrrave sot',
    'Looking for a job': 'Po kërkoj punë',
    "I'm hiring": 'Po punësoj',
    'or sign up with email': 'ose regjistrohu me email',
    'First Name': 'Emri',
    'Last Name': 'Mbiemri',
    'Creating account...': 'Duke krijuar llogarinë...',
    'Create account': 'Krijo llogari',
    'Already have an account?': 'Keni tashmë një llogari?',
    'Welcome!': 'Mirësevini!',
    'Glad to have you here': 'Kënaqësi që ju kemi këtu',
    'Continue to Homepage': 'Vazhdo në faqen kryesore',
    'Follower': 'Ndjekës',
    'Followers': 'Ndjekës',
    'Employees': 'Punonjës',
    'Open vacancy': 'Vend pune',
    'Open vacancies': 'Vende pune',
    'Avg. salary': 'Paga mesatare',
    'Employment Type': 'Tipi i Punësimit',
    'Required experience': 'Eksperienca e kërkuar',
    'Required degree': 'Arsimimi i kërkuar',
    'Email': 'Email',
    'Industry': 'Industria',
    'My profile': 'Profili im',
    'Saved vacancies': 'Vende pune të ruajtura',
    'Applied vacancies': 'Vende pune të aplikuara',
    'View vacancy': 'Shiko vendin e punës',
    'Applied on': 'Aplikuar më',
    'No applied vacancies found.': 'Nuk u gjet asnjë vend pune i aplikuar.',
    'No saved vacancies found.': 'Nuk u gjet asnjë vend pune i ruajtur.',
    'Saved candidates': 'Kandidatë të ruajtur',
    'Notifications': 'Njoftime',
    'Log out': 'Dil',
    'Free': 'Falas',
    'Applied': 'Aplikuar',
    'Apply': 'Apliko',
    'Follow': 'Ndiq',
    'Following': 'Ndiqet',
    'followers': 'ndjekës',
    'employees': 'punonjës',
    'User ID': 'ID e Përdoruesit',
    'Search': 'Kërko',
    'All': 'Të gjitha',
    'In review': 'Në shqyrtim',
    'Interview': 'Intervistë',
    'Reserve': 'Rezervë',
    'Hired': 'Të punësuar',
    'Rejected': 'Të refuzuar',
    'Suggested': 'Sugjerime',
    'Applicant': 'Aplikanti',

    'Status': 'Statusi',
    'Resume': 'CV',
    'View Resume': 'Shiko CV',
    'No Resume': 'Nuk ka CV',
    'No resumes received yet.': 'Nuk ka aplikime të marra ende.',
    'My Vacancies': 'Vendet e mia të punës',
    '+ Add Vacancy': '+ Shto Vend Pune',
    'Title': 'Titulli',
    'Job Created': 'Krijuar Më',
    'Action': 'Veprimi',
    'View': 'Shiko',
    'Edit': 'Ndrysho',
    'Hide': 'Fshih',
    'Delete': 'Fshi',
    'Premium Features are FREE!': 'Funksionet Premium janë FALAS!',
    'To celebrate our launch, all premium features including Featured Vacancies are completely free for the next 2 years.': 'Për të festuar lançimin tonë, të gjitha funksionet premium përfshirë Vendet e Punës të Zgjedhura janë plotësisht falas për 2 vitet e ardhshme.',
    'Your Current Balance': 'Gjendja Juaj Aktuale',
    'You can use these credits when publishing a new vacancy.': 'Mund t\'i përdorni këto kredite kur publikoni një vend të ri pune.',
    '0 Credits': '0 Kredite',
    'Credits': 'Kredite',
    'Unlimited Vacancies': 'Vende Pune të Pafundme',
    'Grow your team without limits. Tani mund të postoni vende pune të zgjedhura pafund dhe të shfaqeni në krye të rezultateve të kërkimit — plotësisht falas.': 'Zgjeroni ekipin tuaj pa kufizime. Tani mund të postoni vende pune të zgjedhura pafund dhe të shfaqeni në krye të rezultateve të kërkimit — plotësisht falas.',
    'Active until 2028': 'Aktiv deri më 2028',
    'Published': 'Publikuar',
    'Expires': 'Skadon',
    'Today': 'Sot',
    'Next': 'Tjetra',
    'Month': 'Muaji',
    'Week': 'Java',
    'Day': 'Dita',
    'Agenda': 'Agjenda',
    'Date': 'Data',
    'Time': 'Koha',
    'Event': 'Ngjarja',
    'No events in this range.': 'Nuk ka ngjarje në këtë varg.',
    'more': 'më shumë',
    'Company Gallery (max 8 images)': 'Galeria e Kompanisë (max 8 imazhe)',
    'Edit Vacancy': 'Modifiko Vendin e Punës',
    'Vacancy Title (ALB)': 'Titulli i Punës (ALB)',
    'Vacancy Title (ENG)': 'Titulli i Punës (ENG)',
    'Save Changes': 'Ruaj Ndryshimet',
    'Upload images of your office, team, or events. Max 3MB per image.': 'Ngarkoni imazhe të zyrës, ekipit, ose eventeve. Maksimum 3MB për imazh.',
    'Add Images': 'Shto Imazhe',
    'Save Profile': 'Ruaj Profilin',
    'Company Profile saved successfully!': 'Profili i kompanisë u ruajt me sukses!',
    'Company User': 'Përdorues i Kompanisë',
    'Account email:': 'Email-i llogarisë:',
    'Company Settings': 'Cilësimet e Kompanisë',
    'FAQ': 'Pyetje të shpeshta',
    'Find answers to common questions about managing your company profile and vacancies.': 'Gjeni përgjigje për pyetjet e shpeshta rreth menaxhimit të profilit tuaj të kompanisë dhe vendeve të punës.',
    'How do I add a new company?': 'Si të shtoj një kompani të re?',
    'You can add a new company directly during your account registration. Simply choose to create a new company, fill in your company details like name, logo, and description, and your company profile will be created instantly.': 'Mund të shtoni një kompani të re drejtpërdrejt gjatë regjistrimit të llogarisë suaj. Thjesht zgjidhni të krijoni një kompani të re, plotësoni detajet e kompanisë suaj si emri, logoja dhe përshkrimi, dhe profili i kompanisë suaj do të krijohet menjëherë.',
    'How do I claim an existing company from the database?': 'Si mund të kërkoj një kompani ekzistuese nga baza e të dhënave?',
    'If your company is already listed in our database, you can claim it by searching for its name during registration. After selecting it, you may need to verify your ownership using an official company email or by contacting our support team for verification.': 'Nëse kompania juaj është tashmë e listuar në bazën tonë të të dhënave, mund ta kërkoni atë duke kërkuar emrin e saj gjatë regjistrimit. Pas përzgjedhjes së saj, mund t\'ju duhet të verifikoni pronësinë tuaj duke përdorur një email zyrtar të kompanisë ose duke kontaktuar ekipin tonë të mbështetjes për verifikim.',
    'How do I post a new vacancy?': 'Si mund të postoj një vend të ri pune?',
    'Click on the "+ Add Vacancy" button in the My Vacancies section. Fill in the job details, requirements, and click "Submit". Your vacancy will be published immediately or saved as a draft.': 'Klikoni butonin "+ Shto Vend Pune" në seksionin "Vendet e mia të punës". Plotësoni detajet e punës, kërkesat dhe klikoni "Dërgo". Vendi juaj i punës do të publikohet menjëherë ose do të ruhet si draft.',
    'How much does it cost to post a vacancy?': 'Sa kushton të postosh një vend pune?',
    'To celebrate our launch, all premium features including posting unlimited featured vacancies are completely free for the next 2 years!': 'Për të festuar lançimin tonë, të gjitha veçoritë premium duke përfshirë postimin e pa kufizuar të vendeve të punës të zgjedhura janë plotësisht falas për 2 vitet e ardhshme!',
    'Can I edit or hide a vacancy after posting?': 'A mund të modifikoj ose fsheh një vend pune pas publikimit?',
    'Yes, you can edit or hide a vacancy at any time from the "My Vacancies" page. Hidden vacancies will no longer be visible to candidates.': 'Po, mund ta modifikoni ose fshihni një vend pune në çdo kohë nga faqja "Vendet e mia të punës". Vendet e punës të fshehura nuk do të jenë më të dukshme për kandidatët.',
    'How do I view candidates who applied for my jobs?': 'Si mund t\'i shoh kandidatët që aplikuan për punët e mia?',
    'Navigate to the "Received" section in your dashboard. You will see a list of all applicants, their resumes, and contact information.': 'Lundroni te seksioni "Të marra" në panelin tuaj. Do të shihni një listë të të gjithë aplikantëve, rezymetë e tyre dhe informacionin e kontaktit.',
    'What are "Suggested" and "Reserve" statuses?': 'Çfarë janë statuset "Sugjeruar" dhe "Rezervë"?',
    'You can organize applicants by moving them to "Suggested" (top candidates), "Interview" (scheduled for an interview), or "Reserve" (good candidates for future roles).': 'Mund t\'i organizoni aplikantët duke i kaluar te "Sugjeruar" (kandidatët më të mirë), "Intervistë" (planifikuar për një intervistë) ose "Rezervë" (kandidatë të mirë për rolet e ardhshme).',
    'How do I upload images to my Company Gallery?': 'Si mund të ngarkoj imazhe në Galerinë e Kompanisë time?',
    'Go to "Company Profile" (Settings) and scroll down to the "Company Gallery" section. You can upload up to 8 images (max 3MB each) showcasing your office and team.': 'Shkoni te "Profili i Kompanisë" (Cilësimet) dhe lëvizni poshtë te seksioni "Galeria e Kompanisë". Mund të ngarkoni deri në 8 imazhe (max 3MB secila) duke shfaqur zyrën dhe ekipin tuaj.',
    'How does the Calendar work?': 'Si funksionon Kalendari?',
    'The Calendar automatically tracks your vacancy publishing dates and expiration dates. This helps you keep a clear timeline of all your active job postings.': 'Kalendari ndjek automatikisht datat e publikimit dhe datat e skadimit të vendeve tuaja të punës. Kjo ju ndihmon të mbani një afat kohor të qartë të të gjitha postimeve tuaja aktive të punës.',
    'How do I enable Two-Factor Authentication (2FA)?': 'Si mund të aktivizoj Autentifikimin me dy faktorë (2FA)?',
    'Go to the "Security" page in your dashboard. Enter your phone number and click "Activate". You will receive an SMS code to verify and secure your account.': 'Shkoni në faqen "Siguria" në panelin tuaj. Futni numrin e telefonit tuaj dhe klikoni "Aktivizo". Do të merrni një kod SMS për të verifikuar dhe siguruar llogarinë tuaj.',
    'Two-Factor Authentication': 'Autentifikimi me dy faktorë',
    'When activating/deactivating, an SMS code will be sent to the number you specified.': 'Gjatë aktivizimit/çaktivizimit, një kod SMS do të dërgohet në numrin që keni specifikuar.',
    'Activate': 'Aktivizo',
    'Set Password': 'Vendos Fjalëkalimin',
    'Since you logged in with a social account, you can set a password to log in directly via email in the future.': 'Meqenëse jeni kyçur me një llogari sociale, mund të vendosni një fjalëkalim për t\'u kyçur direkt përmes email-it në të ardhmen.',
    'New Password': 'Fjalëkalimi i ri',
    'Enter new password': 'Shkruani fjalëkalimin e ri',
    'Confirm New Password': 'Konfirmo Fjalëkalimin e ri',
    'Confirm new password': 'Konfirmoni fjalëkalimin e ri',
    'Who can use two-factor authentication?': 'Kush mund të përdorë autentifikimin me dy faktorë?',
    'All users added to the company will be able to log into the system using their specified numbers.': 'Të gjithë përdoruesit e shtuar në kompani do të mund të kyçen në sistem duke përdorur numrat e tyre të specifikuar.',
    'What does two-factor authentication protect in my system?': 'Çfarë mbron autentifikimi me dy faktorë në sistemin tim?',
    'With two-factor authentication, you can increase the level of security in your system.': 'Me autentifikimin me dy faktorë, mund të rrisni nivelin e sigurisë në sistemin tuaj.',
    'Company Profile!': 'Profili i Kompanisë!',
    'Ready to jump back in?': 'Gati për të vazhduar?',
    'Company logo': 'Logo e kompanisë',
    'Upload new photo': 'Ngarko foto të re',
    'Company name *': 'Emri i kompanisë *',
    'Email address *': 'Adresa e email-it *',
    'Phone *': 'Numri i telefonit *',
    'Visible on public profile': 'I dukshëm në profilin publik',
    'Website': 'Uebfaqja',
    'Founded Date': 'Data e Themelimit',
    'Team Size': 'Madhësia e Ekipit',
    'Import And Claim Company': 'Importo dhe Merr Kompaninë',
    'Full Stack Developer': 'Zhvillues Full Stack',
    'Help Desk Support': 'Suport Help Desk',
    'Back Office': 'Back Office',
    'Data entry': 'Data Entry',
    'HYDRAULIC': 'Hidraulik',
    'PLUMBER': 'Hidraulik',
    'Advance Filter': 'Filtër i Avancuar',
    'Advanced Filter': 'Filtër i Avancuar',
    'Date Descending': 'Data në zbritje',
    'Date Ascending': 'Data në rritje',
    'Salary Descending': 'Paga në zbritje',
    'Salary Ascending': 'Paga në rritje',
    'jobs found': 'vende pune të gjetura',
    'Clear filters': 'Pastro filtrat',
    'Send Resume': 'Dërgo CV-në',
    'Fill Information': 'Plotëso të Dhënat',
    'Upload Resume *': 'Ngarko CV-në *',
    'Upload Resume': 'Ngarko CV-në',
    'pdf, docx, doc • Max file size 4MB': 'pdf, docx, doc • Madhësia maksimale 4MB',
    'I agree to the': 'Unë pranoj',
    'Terms & Conditions': 'Termat dhe Kushtet',
    'and accept the': 'dhe pranoj',
    'processing of my personal data': 'përpunimin e të dhënave të mia personale',
    'Send': 'Dërgo',
    'Sending...': 'Duke dërguar...',
    'Your resume has been forwarded to the company.': 'CV-ja juaj i është përcjellë kompanisë me sukses.',
    'Mobile (+355 xx xxx xxx)': 'Numri i Celularit (+355 xx xxx xxx)',
    'Expired': 'Ka skaduar',
    'This vacancy has expired': 'Afati i këtij pozicioni ka skaduar',
    'Applications are closed for this position': 'Aplikimet janë mbyllur për këtë pozicion',
  }
};
